import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IUserNew } from '../models/user';
import { API, graphqlOperation } from 'aws-amplify';
import { Mutations, Queries } from './appsync-services';
import { GraphQLResult } from '@aws-amplify/api/lib/types';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }

  getAllUsers() {
    return this.http.get<IUserNew[]>('http://dev.focalcxm.com/playclay/rest/login/getAllSubUsers?companyName=FocalCXM');
  }

  async getAllUsersQuery($envId: number) {
    const getUsersQuery = new Queries().listAllUsers;
    const userDetails = {
      envId: $envId
    };
    const allUsers = await API.graphql(graphqlOperation(getUsersQuery, userDetails));
    return allUsers;
  }

  async appsynMutations() {
    const getUsersQuery = `query getUsers($envId: Int) {
      getUsers(
        envId: $envId
      ) {
        body
      }
    }`;

    const newEvent = await API.graphql(graphqlOperation(getUsersQuery, { envId: 75 }));
    return newEvent;
  }

  async updateUserData(user: IUserNew) {
    const updateUserDemographic = new Mutations().updateUserData;
    return API.graphql(graphqlOperation(updateUserDemographic, user)) as Promise<GraphQLResult>;
  }
}
